import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 1,
        rows: 2,
        rowsSize: [8, 1],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "video",
                  options: {
                    src: `${config.ASSETS_URL}/03/23/principle/principle-3-full-mix.mp4`,
                  },
                },
                styles: {
                  padding: "3%",
                },
              },
            },
          ],
          [],
        ],
      },
    },
  },
];

export default components;
